export const toAlpha = (num) => {
  // 1 -> a, 2 -> b, ... 26 -> z, 27 -> aa, etc.
  let s = "";
  while (num > 0) {
    num -= 1;
    s = String.fromCharCode(97 + (num % 26)) + s;
    num = Math.floor(num / 26);
  }
  return s;
};
